<script lang="ts">
  import { Accordion as AccordionPrimitive } from 'bits-ui-v2'
  import { cn } from '$lib/cn'

  let {
    ref = $bindable(null),
    class: className,
    children,
    ...restProps
  }: Omit<AccordionPrimitive.ContentProps, 'child'> = $props()
</script>

<AccordionPrimitive.Content
  bind:ref
  data-slot="accordion-content"
  class="accordion-content overflow-hidden"
  {...restProps}
>
  <div class={cn('pb-4 pt-0', className)}>
    {@render children?.()}
  </div>
</AccordionPrimitive.Content>

<style>
  :global(.accordion-content[data-state='open']) {
    animation: accordion-down 200ms ease-out;
  }

  :global(.accordion-content[data-state='closed']) {
    animation: accordion-up 200ms ease-out;
  }

  @keyframes accordion-down {
    from {
      height: 0;
    }
    to {
      height: var(--bits-accordion-content-height);
    }
  }

  @keyframes accordion-up {
    from {
      height: var(--bits-accordion-content-height);
    }
    to {
      height: 0;
    }
  }
</style>
